import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import { supportMail } from "../../config";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
	modalHeader: {
		borderBottom: 'none !important',
		paddingTop: '11px',
		paddingRight: '4px',
		marginTop: '-7px',
		display: "block !important"
	},
	footerDiv: {
		padding: "0 10px",
	},
	buttonStyle: {
		float: "right",
		textTransform: "none",
		margin: "4px",
		backgroundColor: "#d98638",
	},
	buttonStyles: {
		float: "right",
		textTransform: "none",
		margin: "4px",
	},
	ModalDesign: {
		// width:'60px'
		marginRight: "106px",
	},
	selectorValues: {
		marginRight: "300px",
	},
	projTitleActive: {
		backgroundColor: '#008EC5',
		color: '#fff',
		padding: '3px',
		borderRadius: '3px'
	},
	buttonStyleCancel: {
		float: 'right',
		textTransform: 'none',
		margin: '4px',
		color: 'white',
		backgroundColor: '#008EC5 !important',
		border: '1px solid #1F4E79 !important',
		borderColor: '#1F4E79',

	},
	scrollList: {
		maxHeight: '200px',
		overflowY: 'auto',
		overflowX: 'hidden'
	},
	modalBoxContent: {
		maxHeight: '100vh',
		display: 'flex !important',
		justifyContent: 'center !important',
		alignItems: 'center !important',
		position: 'fixed',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		zIndex: '1050'
	},
	modalBody: {
		flex: 'unset',
		padding: '10px 10px 15px',
		maxHeight: '80vh',
		overflowY: 'auto',
		border: 'none !important'
	},

	modalBodyDark: {
		flex: 'unset',
		padding: '10px 10px 15px',
		backgroundColor: '#292929',
		maxHeight: '80vh',
		overflowY: 'auto',
		border: 'none !important'
	},
	modalClassContent: {
		width: '96%',
		maxWidth: '600px',
		maxHeight: '90vh',
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		overflowY: 'auto',
		margin: 'auto',
		border: 'none !important',
		outline: 'none !important'
	},
	colorContainer: {
		backgroundColor: '#EEEEEE',
		paddingTop: '15px',
		paddingBottom: '70px',
		marginLeft: '5px',
		marginRight: '4px',
		paddingRight: '10px',
		borderRadius: '5px',
		paddingLeft: '10px',
		minHeight: '300px'
	},
	colorContainerDark: {
		backgroundColor: '#56545473',
		paddingTop: '15px',
		paddingBottom: '70px',
		marginLeft: '5px',
		marginRight: '4px',
		paddingRight: '10px',
		borderRadius: '5px',
		paddingLeft: '10px',
		minHeight: '300px'
	},
	closeButton: {
		position: 'absolute',
		right: '10px',
		top: '10px'
	}
}));

function ShareResultsModal(props) {
	const classes = useStyles();
	const { t, i18n } = useTranslation("common");
	const [selectData, setSelectData] = useState([]);
	const [externalSharing, setExternalSharing] = useState(false);
	const [emails, setEmails] = useState('');
	const [formaterr, setFormaterr] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const toggle = useSelector(state => state.setToggle.toggle);

	const getSelectVal = (id) => {
		let getStateVal = selectData;
		if (selectData.includes(id)) {
			getStateVal = getStateVal.filter(e => e !== id);
			setSelectData(getStateVal);
		} else {
			selectData.push(id);
			setSelectData([...selectData]);
		}
	}

	const shareUserData = () => {
		props.shareResult(selectData)
		setSelectData([]);
	}

	const isValidEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	const handleEmailChange = (e) => {
		setEmails(e.target.value);
		setFormaterr(false);
	}

	const shareEmailResults = () => {
		let invalid = 0;
		setFormaterr(false);
		const emailLines = emails.split('\n').map(line => line.trim()).filter(line => line.length > 0);

		if (emailLines.length > 0) {
			for (const email of emailLines) {
				if (!isValidEmail(email)) {
					setFormaterr(true);
					invalid = 1;
				}
			}
		} else {
			invalid = 1;
			setFormaterr(true);
		}

		if (!invalid) {
			const joinedEmails = emailLines.join(';');
			if (props.actionModal) {
				props.actionModal(joinedEmails);
			}
			closeModal();
		}
	}

	const closeModal = () => {
		props.onHide();
		setSelectData([]);
		setExternalSharing(false);
		setEmails('');
		setFormaterr(false);
		setSearchTerm('');
	}
	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcente"
			centered={true}
			contentClassName={classes.modalClassContent}
			className={classes.modalBoxContent}
			backdrop="static"
			dialogClassName="border-0"
		>
			{/* <Modal.Header
				// closeButton
				className={classes.modalHeader}
			>
				{/* <Link href="#" onClick={(e) => e.preventDefault()} className={"float-right  appTextColor"}><CloseIcon onClick={closeModal} /></Link> */}

			{/* <Modal.Title id="contained-modal-title-vcenter">
           Logout
          </Modal.Title>


		</Modal.Header> * /}
			{/* <h5>Share these Results.</h5> */ }
			<Link href="#" onClick={(e) => e.preventDefault()} className={classes.closeButton + "  appTextColor"}><CloseIcon onClick={closeModal} /></Link>
			<div className={toggle ? classes.modalBody : classes.modalBodyDark+ " appTextColor"}>
			{/* <div className={(toggle ? classes.modalBody : classes.modalBodyDark) + " appTextColor"}> */}
				{/* <h5>{props.onMessage}</h5> */}

				<div className={toggle ? classes.colorContainer: classes.colorContainerDark}>
					<h5>
						&nbsp;<b>{'Share ' + (props.sharedItem ? props.sharedItem : 'these results')}</b>
					</h5>
					<div className={classes.ModalDesign}>
						<p className="pl-2 pb-0">
							{'Select one or more people to share ' + (props.sharedItem ? props.sharedItem : 'these results') + ' with.'}
						</p>
					</div>

					{props.showExternalCheckbox && (
						<div className="pl-2 pb-3" style={{ display: 'flex', alignItems: 'center' }}>
							<input
								type="checkbox"
								id="externalSharingCheckbox"
								checked={externalSharing}
								onChange={(e) => setExternalSharing(e.target.checked)}
								style={{ marginRight: '8px', transform: 'scale(1.2)' }}
							/>
							<label htmlFor="externalSharingCheckbox" style={{ margin: 0, cursor: 'pointer', color: toggle ? '#000' : '#fff' }}>
								Sharing with people outside my organisation
							</label>
						</div>
					)}

					{!externalSharing && (
						<div className={classes.selectorValues + " mx-4"}>
							<input
								type="text"
								placeholder="Search by name..."
								value={searchTerm}
								onChange={(e) => setSearchTerm(e.target.value)}
								style={{
									width: '50%',
									padding: '6px 10px',
									marginBottom: '8px',
									marginLeft: '-2px',
									border: '1px solid #ccc',
									borderRadius: '4px',
									fontSize: '14px',
									backgroundColor: toggle ? '#fff' : '#666666',
									color: toggle ? '#000' : '#fff'
								}}
							/>
							<ul className={"list-inline " + classes.scrollList}>
								{
									props.data && Object.keys(props.data)
										.filter((dta) => props.data[dta].full_name.toLowerCase().includes(searchTerm.toLowerCase()))
										.map((dta, i) => {
										return <li key={i}>
											<span className={"cursorPointer " + (selectData.includes(props.data[dta].user_id) ? classes.projTitleActive : '')} onClick={() => getSelectVal(props.data[dta].user_id)}>{props.data[dta].full_name}</span>
										</li>
									})
								}
							</ul>
						</div>
					)}

					{externalSharing && (
						<div className={classes.selectorValues + " mx-4"} style={{ marginTop: '20px' }}>
							<h6 style={{ color: toggle ? '#000' : '#fff', marginBottom: '10px' }}>Enter the Email addresses that you want to share this with.</h6>
							<textarea 
								value={emails} 
								onChange={handleEmailChange}
								id="Email"
								name="Email"
								placeholder="Enter email addresses, one per line" 
								style={toggle ? 
									{ border: '1px solid #dcd7c0', width: '75%', height: '90px', fontFamily: 'verdana, helvetica', fontSize: '14px', padding: '8px' } : 
									{ border: '1px solid #dcd7c0', width: '75%', height: '90px', fontFamily: 'verdana, helvetica', fontSize: '14px', backgroundColor: '#666666', color: 'white', padding: '8px' }
								}
							/>
							{formaterr && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>Invalid email format</div>}
						</div>
					)}
					<div className={classes.footerDiv + " float-right"}>
						{externalSharing ? (
							<>
								{emails.length > 0 && 
									<Button
										color="secondary"
										variant="contained"
										className="text-capitalize mr-2 accountInfo"
										onClick={shareEmailResults}
										disableRipple={true}
									>
										Share Results
									</Button>
								}
							</>
						) : (
							<Button
								color={selectData.length == 0 ? "default" : "secondary"}
								variant="contained"
								className={"text-capitalize mr-2 " + (selectData.length == 0 ? 'cancelButtonDisable' : 'accountInfo')}
								onClick={shareUserData}
								disableRipple={true}
								disabled={selectData.length == 0 ? true : false}
							>{'Share ' + (props.sharedItem ? props.sharedItem : 'Results')}</Button>)}
						<Button
							onClick={closeModal}
							className={classes.buttonStyleCancel}
							color="secondary"
							disableRipple={true}
							variant="contained"
						>Cancel</Button>

					</div>
				</div>
			</div>
			{/* <Modal.Footer>
				<Button onClick={props.onHide}>Close</Button>
			</Modal.Footer> */}
		</Modal >
	);
}

export default ShareResultsModal;
